// Copyright © 2026 Playcast, Inc. All rights reserved.

export type PausableStreamMedia = {
  pause: () => void;
  play: () => Promise<void>;
  srcObject: unknown;
};

export type PausableStreamAudio = PausableStreamMedia & {
  muted: boolean;
};

export function pageHidesStream(visibilityState: string): boolean {
  return visibilityState === 'hidden';
}

/**
 * Pause both elements when hidden. Otherwise attempt playback only for elements
 * with srcObject, skipping muted audio. Play promise rejections are ignored;
 * synchronous media-method errors propagate.
 */
export function applyStreamPlaybackForPageVisibility(
  visibilityState: string,
  video: PausableStreamMedia | null,
  audio: PausableStreamAudio | null,
): void {
  if (pageHidesStream(visibilityState)) {
    video?.pause();
    audio?.pause();
    return;
  }

  if (video?.srcObject) {
    void video.play().catch(() => undefined);
  }
  if (audio?.srcObject && !audio.muted) {
    void audio.play().catch(() => undefined);
  }
}
